import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/iv_profile.png'


const _hoisted_1 = { class: "profile-page" }


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfilePage',
  setup(__props) {

const shootProfile = () => {
  //촬영 함수
  alert("촬영");

}
const openProfile = () => {
  //열기 함수
  alert("열기");
}
const deleteProfile = () => {
  //삭제 함수
  alert("삭제");
}
const detailProfile = () => {
  //상세정보 보기 함수
  alert("상세정보");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "profile-page__left" }, [
      _cache[2] || (_cache[2] = _createElementVNode("img", {
        src: _imports_0,
        class: "profile-page__image-profile",
        alt: "Profile image"
      }, null, -1)),
      _createElementVNode("div", { class: "profile-page__button_wrapper" }, [
        _createElementVNode("div", {
          class: "profile-page__button",
          onClick: shootProfile
        }, "촬영"),
        _createElementVNode("div", {
          class: "profile-page__button",
          onClick: openProfile
        }, "열기"),
        _createElementVNode("div", {
          class: "profile-page__button",
          onClick: deleteProfile
        }, "삭제")
      ]),
      _createElementVNode("div", { class: "profile-page__left_container" }, [
        _cache[1] || (_cache[1] = _createStaticVNode(" 보험정보 <div class=\"profile-page__left_container_body\"><div class=\"profile-page__left_container_body_title\"><span> 구분 </span><span> 가입자 </span><span> 증번호 </span><span> 사업자 </span><span> 공상 </span></div><div class=\"profile-page__left_container_body_table\"><table><tr><td>건강보험</td></tr><tr><td>파이퀀트</td></tr><tr><td>2024052401</td></tr><tr><td>국민건강보험</td></tr><tr><td></td></tr></table></div></div>", 2)),
        _createElementVNode("div", { class: "profile-page__left_container_footer" }, [
          _cache[0] || (_cache[0] = _createElementVNode("span", null, " 본원 ", -1)),
          _createElementVNode("span", {
            class: "profile-page__detail_profile_button",
            onClick: detailProfile
          }, " 상세정보 보기 ")
        ])
      ])
    ])
  ]))
}
}

})